/** Typed access to Vite env. Only public values belong here — never secrets. */
function read(name: keyof ImportMetaEnv, fallback = ""): string {
  const value = import.meta.env[name];
  return typeof value === "string" && value.length > 0 ? value : fallback;
}

export const env = {
  apiBaseUrl: read("VITE_API_BASE_URL", "http://localhost:8000/api/v1").replace(/\/$/, ""),
  wsBaseUrl: read("VITE_WS_BASE_URL", "ws://localhost:8000/ws").replace(/\/$/, ""),
  /** VITE_WS_BASE_URL=off (serverless API without WebSockets): the app polls instead. */
  realtimeEnabled: read("VITE_WS_BASE_URL", "ws://localhost:8000/ws").toLowerCase() !== "off",
  googleClientId: read("VITE_GOOGLE_CLIENT_ID"),
  cloudinaryCloudName: read("VITE_CLOUDINARY_CLOUD_NAME"),
  sentryDsn: read("VITE_SENTRY_DSN"),
  /** The web app's address without https:// (e.g. realitystore.com.ng), for hints like store links. */
  siteHost: (() => {
    const fallback = typeof window === "undefined" ? "" : window.location.origin;
    try {
      return new URL(read("VITE_SITE_URL", fallback)).host;
    } catch {
      return "";
    }
  })(),
  isDev: import.meta.env.DEV,
} as const;
